import {Mutation} from './mutation-types'
import kanban from "../../../control_produccion/components/Kanban";
import productionLine from "../../../monitorization/components/ProductionLine";
import {OrderStates} from "../../../control_produccion/utils";
import machine from "../../../monitorization/components/Machine";
import {showWarning} from "../utils";
export default {

    [Mutation.CREATE_COLLAPSE_STATE] (state, {accordionCollapseState}){
        if(!accordionCollapseState)
            return showWarning('Collapsable no valido, imposible crear')

        if(state.accordionCollapseStates.find(a => a.id == accordionCollapseState.id))
            return showWarning(`Collapsable ya existente (id ${accordionCollapseState.id})`)

        state.accordionCollapseStates.push(accordionCollapseState)
        return state.accordionCollapseStates;
    },
    [Mutation.UPDATE_COLLAPSE_STATE] (state, {accordionCollapseState}){
        if(!accordionCollapseState)
            return showWarning('Collapsable no valido, imposible actualizar')

        let accordionCollapseStateToUpdate = state.accordionCollapseStates.find(a => a.id == accordionCollapseState.id)
        if(!accordionCollapseStateToUpdate)
            return showWarning(`Collapsable no existente (id ${accordionCollapseState.id})`)

        state.accordionCollapseStates[state.accordionCollapseStates.findIndex(a => a.id == accordionCollapseState.id)] = {
            ...accordionCollapseStateToUpdate,
            ...accordionCollapseState
        }

        return state.accordionCollapseStates;

    },
    [Mutation.DELETE_COLLAPSE_STATE] (state, {accordionCollapseStateId}){
        if(isNaN(accordionCollapseStateId))
            return showWarning('Id de collapsable no valido, no es numerico')

        let accordionCollapseStateToDeleteIndex = state.accordionCollapseStates.findIndex(a => a.id == accordionCollapseStateId)
        if(accordionCollapseStateToDeleteIndex == -1)
            return showWarning(`Collapsable no existente (id ${accordionCollapseStateId})`)

        state.accordionCollapseStates.splice(accordionCollapseStateToDeleteIndex, 1);

        return state.accordionCollapseStates;

    },
    [Mutation.CLOSE_COLLAPSE_STATES] (state, {exceptions = []}){
        if(exceptions.length > 0){
            state.accordionCollapseStates.forEach((a, index) => {
                if(!exceptions.includes(a.id))
                    state.accordionCollapseStates[index].collapsed = true;
            })
        }
    },

    [Mutation.CREATE_ROW] (state, {row}){
        if(!row)
            return showWarning('Row invalida, inposible crear')

        if(state.rows.find(r => r.key == row.key))
            return showWarning(`Row ya existente (key ${row.key})`)

        state.rows.splice(row.index, 0,row)
        return state.rows;

    },
    [Mutation.UPDATE_ROW] (state, {row}){
        if(!row)
            return showWarning('Row invalida, imposible actualizar')

        let rowToUpdate = state.rows.find(r => r.key == row.key)
        if(!rowToUpdate)
            return showWarning(`Row inexistente (key ${row.key})`)

        state.rows.splice(row.index, 1, {
            ...rowToUpdate,
            ...row
        })
        return state.rows;
    },
    [Mutation.DELETE_ROW] (state, {rowKey}){
        if(isNaN(rowKey))
            return showWarning('Id de row no valida, no es numerica')

        let rowToDeleteIndex = state.rows.findIndex(r => r.key == rowKey);
        if(rowToDeleteIndex == -1)
            return showWarning(`Row no encontrada (key ${rowKey})`)

        state.rows.splice(rowToDeleteIndex, 1)
        return state.rows
    },
    [Mutation.DELETE_ALL_ROWS] (state) {
        //TODO: Poner posibilidad de excepciones si hiciera falta
        state.rows = [];
        return state.rows;
    }



}
